import { RequestHook } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useRequest = (id: string | undefined): RequestHook => {
  const { requestStore } = useStore();
  const { request, loading } = requestStore;

  useEffect(() => {
    id && requestStore.get({ id });

    return () => {
      requestStore.clearRequest();
    };
  }, [requestStore, id]);

  return { request, loading };
};
